<div class="layout-topbar">
    <div class="topbar-start">
        <button #menubutton type="button" class="topbar-menubutton p-link p-trigger" (click)="onMenuButtonClick()">
            <i class="pi pi-bars"></i>
        </button>

        <!-- <app-breadcrumb class="topbar-breadcrumb"></app-breadcrumb> -->
        <div>
            <div class="d-flex align-items-center gap-1 gap-lg-3">
                <div class="img-container s-46">
                    <img src="https://tigosuperappstorage.blob.core.windows.net/tz-tigo-business-images/user-icon.png"
                        alt="">
                </div>
                <!-- <p-menu #menu appendTo="body" [model]="menuitem" [popup]="true"></p-menu> -->
                <div>
                    <p class="title md font-r lh-1 text-truncate" style="cursor: pointer;">{{ 'TOPBAR.GREETING' | translate:{ name: userName } }}</p>
                    <p class="text lh-1">{{role}}</p>
                </div>
            </div>
            <p class="title xl">{{ 'TOPBAR.WELCOME_BACK' | translate }}</p>
        </div>

    </div>

    <div class="topbar-end">
        <ul class="topbar-menu">
            <!-- <li class="d-none d-lg-block">
        <div class="topbar-search" [ngClass]="{'topbar-search-active': searchActive}">
            <button pButton icon="pi pi-search" class="topbar-searchbutton p-button-text p-button-secondary text-color-secondary p-button-rounded flex-shrink-0" type="button" (click)="activateSearch()"></button>
            <div class="search-input-wrapper">
                <span class="p-input-icon-right">
                    <input #searchinput type="text" pInputText placeholder="Search" (blur)="deactivateSearch()" (keydown.escape)="deactivateSearch()"/>
                    <i class="pi pi-search"></i>
                </span>
            </div>
        </div>
    </li> -->

            <!--<li class="topbar-item ">
                <button type="button" class="header-notification-btn" routerLink="/app/account-settings/notifications"><i class="pi pi-bell"></i></button>
            </li>-->
            <div class="last-login d-flex align-items-center gap-2">
                <i class="last-login-icon pi pi-calendar"></i>
                <div class="last-login-details">
                    <p class="last-login-label">{{ 'TOPBAR.LAST_LOGIN_AT' | translate }}</p>
                    <p class="last-login-value">{{ previousLoginFormatted || lastLoginFormatted || (previousLogin | date: 'dd MMMM yyyy \'at\' hh:mm a')}}</p>
                </div>
            </div>
            <li class="topbar-item ">
                <button type="button" class="" (click)="checkRouteAndRedirect()"><i class="pi pi-cog"></i></button>
            </li>
            <!-- <li  class="profile-item topbar-item " >
        <button pButton type="button" icon="pi pi-comment"  class="p-button-text p-button-secondary relative text-color-secondary p-button-rounded flex-shrink-0"></button>
    </li> -->
            <!-- <li class="ml-3">
        <button pButton type="button" icon="pi pi-cog" class="p-button-text p-button-secondary text-color-secondary p-button-rounded flex-shrink-0" (click)="onConfigButtonClick()"></button>
    </li> -->
            <!-- <li #profile class="profile-item topbar-item " >
        <a pStyleClass="@next" enterFromClass="ng-hidden" enterActiveClass="px-scalein" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout" [hideOnOutsideClick]="true" pRipple class="cursor-pointer">
            <img class="border-circle" src="assets/demo/images/avatar/square/avatar-m-1.jpg">
        </a>

        <ul class="topbar-menu active-topbar-menu p-4 w-15rem z-5 ng-hidden border-round">
            <li role="menuitem" class="m-0 mb-3">
                <a href="#" class="flex align-items-center hover:text-primary-500 transition-duration-200" pStyleClass="@grandparent" enterFromClass="ng-hidden" enterActiveClass="px-scalein" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout">
                    <i class="pi pi-fw pi-lock mr-2"></i>
                    <span>Privacy</span>
                </a>
            </li>
            <li role="menuitem" class="m-0 mb-3">
                <a href="#" class="flex align-items-center hover:text-primary-500 transition-duration-200" pStyleClass="@grandparent" enterFromClass="ng-hidden" enterActiveClass="px-scalein" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout">
                    <i class="pi pi-fw pi-cog mr-2"></i>
                    <span>Settings</span>
                </a>
            </li>
            <li role="menuitem" class="m-0">
                <a href="#" class="flex align-items-center hover:text-primary-500 transition-duration-200" pStyleClass="@grandparent" enterFromClass="ng-hidden" enterActiveClass="px-scalein" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout">
                    <i class="pi pi-fw pi-sign-out mr-2"></i>
                    <span>Logout</span>
                </a>
            </li>
        </ul>
    </li>

    <li class="right-panel-button relative hidden d-lg-block">
        <button pButton  type="button" label="Today" style="width:5.7rem" icon="pi pi-bookmark"
        class="layout-rightmenu-button d-none d-md-block font-normal" styleClass="font-normal" (click)="onSidebarButtonClick()"></button>
        <button pButton type="button" icon="pi pi-bookmark" styleClass="font-normal" class="layout-rightmenu-button d-block d-md-none" (click)="onSidebarButtonClick()"></button>
    </li> -->
        </ul>
    </div>
</div>


<p-dialog [(visible)]="approvalDialog" [modal]="true" [style]="{ width: '600px' }" [draggable]="false"
    [resizable]="false" [closable]="false">
    <div class="text-center">
        <div class="animated-check-circle"></div>
        <p class="title">{{ 'COMMON.DEAR_CUSTOMER' | translate }}</p>
        <p class="text">{{ 'TOPBAR.ACCOUNT_APPROVAL_MESSAGE' | translate }}</p>
        <button class="btn btn-primary mt-4" (click)="closePopup()">{{ 'COMMON.OK' | translate }}</button>
    </div>
</p-dialog>
